// @flow
import * as React from 'react'
import moment from 'moment'
import { FormattedMoment } from 'mz-intl'
import ClockIcon from 'mz-icons/clock'
import BaseField from '../../../core/BaseField'
import { LightboxBaseField } from '../../../core/LightboxBaseField'
import DesktopTimeLightbox from './Lightbox'
import { is12hFormat } from '../../../utils'
import { HOUR_FORMAT, HOUR_FORMAT_24H } from '../utils'

// Types
import type { Props as BaseFieldProps } from '../../../core/BaseField'
import type { AppearanceTitle } from '../../../core/Lightbox'

export type Props = BaseFieldProps & {
  roundMinutes?: boolean,
  roundMinutesInterval: number,
  lightboxTitle?: AppearanceTitle,
  lightboxSubtitle?: AppearanceTitle,
}

/**
 * Desktop time picker with lightbox
 */
class DesktopTimeField extends React.Component<Props> {
  static defaultProps = {
    ...BaseField.defaultProps,
    roundMinutes: true,
    roundMinutesInterval: 5,
  }

  renderLightbox = ({ setFocusableRef, select, cancel }: *) => (
    <DesktopTimeLightbox
      roundMinutes={this.props.roundMinutes}
      roundMinutesInterval={this.props.roundMinutesInterval}
      input={this.props.input}
      setFocusableRef={setFocusableRef}
      onSelect={select}
      onCancel={cancel}
    />
  )

  renderValue = (value: ?moment, render: *) => {
    const actualFormat = is12hFormat() ? HOUR_FORMAT : HOUR_FORMAT_24H
    return (
      <FormattedMoment value={value} format={actualFormat}>
        {render}
      </FormattedMoment>
    )
  }

  render() {
    return (
      <LightboxBaseField
        {...this.props}
        renderPrefix={() => <ClockIcon />}
        renderValue={this.renderValue}
        renderLightbox={this.renderLightbox}
        emptyValue={null}
      />
    )
  }
}

export default DesktopTimeField
